/**
 * @desc 将监控视频流转成flv格式
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** path */
  path?: string;
}

export function request(params: Params): Promise<any> {
  return defHttp.get({
    url: '/rstp/video',

    params,
  });
}

export function mock(params: Params): Promise<any> {
  return defHttp.get({
    url: '/mock/rstp/video',

    params,
  });
}
